<template>
    <div>
        <div class="outerDiv">
            <div class="innerDiv">
                <div>
                    <span class="articleHeading">Latest Articles</span>
                </div>
                    <div class="catorySelector col-xs-12 col-md-3">
                        <Select v-model="categorySelected" clearable filterable style="catagory-select" size="large" placeholder="All Categories">
                            <Option v-for="item in categories" :value="item.slug" :key="item.ID">{{ item.name }}</Option>
                        </Select>
                    </div>
                </div>
                <div class="mainArticle" v-if="posts.length>0">
                    <div class="row">
                        <div
                            v-for="post in posts"
                            :key="post.id"
                            class="col-xs-12 col-md-3 posts"
                        >
                                <PostCard 
                                    :image="post.featured_image"
                                    :categories="LoopOverObject(post.terms.category)"
                                    :id="post.ID"
                                    :title="post.title"
                                    :updatedAt="post.modified"
                                    :author="post.author"
                                    :colorValue="GetColorBasedOnFirstElement(LoopOverObject(post.terms.category))"
                                />
                        </div>
                    </div>
                </div>
                <div v-else>
                    Loading.
                </div>
            </div>
            <div class="containerPagination">
                <Page class="center" :page-size=20 :total="totalElements" @on-change="pageChangeEvent"/>
            </div>
        </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { APIService } from "../ApiService.js";
import PostCard from "./PostCard.vue";
export default {
    
   components: {
     PostCard,
   },
    computed: {
        ...mapState([
        "categories",
        "posts"
        ])
    },
    data(){
        return {
            categorySelected:"",
            colorMap:{},
            totalElements:0
        }
    },
    methods: {
        ...mapMutations(["set_Categories", "set_Posts"]),
        getAllCategories(){
            this.$Loading.start();
            APIService.get(`categories`).then(response => {
                if(response.data && response.data.found>0){
                    this.set_Categories(response.data.categories);
                    this.setColorMap(response.data.categories)
                    this.$Loading.finish();
                }
                else{
                    this.$Loading.error();
                }
                console.log(response);
            }); 
        },
        getPagePosts(pageNumber = 1){
            this.$Loading.start();
            this.$Spin.show();
            var query = "?page=" + pageNumber;
            if(this.categorySelected){
                query += "&category=" + this.categorySelected;
            }
            APIService.get(`posts` + query).then(response => {
                if(response.data && response.data.found>0){
                    this.set_Posts(response.data.posts);
                    this.totalElements = response.data.found
                    this.$Loading.finish();                    
                }
                else{
                    this.$Loading.error();
                }
                this.$Spin.hide();
                console.log(response);
            }); 
        },
        LoopOverObject(objectData){
            var arr = []
            for (var key in objectData) {
                if (Object.prototype.hasOwnProperty.call(objectData, key)) {
                    arr.push(objectData[key]);
                }
            }
            return arr
        },
        setColorMap(categories){
            var self = this
            categories.forEach(item =>{
                if(!self.colorMap[item.ID]){
                    self.colorMap[item.ID] = self.getRandomColor();
                }
            })
        },
        getRandomColor() {
            var letters = '0123456789ABCDEF';
            var color = '#';
            for (var i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        },
        GetColorBasedOnFirstElement(element){
            if(!this.colorMap[element[0].ID]){
                this.colorMap[element[0].ID] = this.getRandomColor();
            }
            return this.colorMap[element[0].ID]
        },
        pageChangeEvent(pageNumber){
            this.set_Posts([]);
            this.getPagePosts(pageNumber);
        }
    },
    created() {
        this.getAllCategories()
        this.getPagePosts()
    },
    watch: {
      "categorySelected": function (){
          this.getPagePosts()
      }  
    }
};
</script>

<style scoped>
.articleHeading{
  font-size: 3vw;
  font-family: 'Outfit', sans-serif;
  font-weight: 600;
  color: #504f4f;
}
.postImage{
  width: 200px;
}

@media only screen and (max-width: 600px) {
.mainArticle{
    padding: 20px 10px 0px 12px
}
.apps{
    padding: 0px 6px 10px 3px;
}
.articleHeading{
  font-size: 2rem;
  padding-left: 13px
}
.catagory-select{
    width: 98%;
}
.posts{
    padding-bottom: 10px;
}
}
@media screen and (min-width: 768px) { 
.mainArticle{
    padding-top: 20px;
}
.outerDiv{
  padding-left: 10%;
  padding-top: 1%;
  padding-right: 10%;
}
.apps{
    padding: 0px 0px 10px 6px;
}
.postCard.ivu-card-body{
    padding: 0px;
}
.articleHeading{
  font-size: 3vw;
}
.catorySelector{
    padding-left: 0px;
}
.posts{
    padding-left: 10px;
    padding-bottom: 10px;
}
.catagory-select{
    width: 100%;
}
.containerPagination{
    padding-top: 30px;
    padding-bottom: 20px;
    display: flex;
    justify-content: center;
}
}
</style>
<style>


</style>